import axios from '../axios';
import { REGULAR_MENU_ORDER_API, DISCOUNT_CODE_VALIDATION_API } from '../../global/ApiUrl';

export const PayAsYouGoOrderAPI = async (payload) => {
  try {
    const response = await axios.post(REGULAR_MENU_ORDER_API, payload);
    return response;
  } catch (error) {
    console.log('PayAsYouGoOrderAPI catch block', error);
    return { success: false, error };
  }
};

export const DiscountCodeValidationAPI = async (payload) => {
  try {
    const response = await axios.post(DISCOUNT_CODE_VALIDATION_API, payload);
    return response;
  } catch (error) {
    console.log('DiscountCodeValidationAPI catch block', error);
    return { success: false, error };
  }
};
